import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { IMaterialDetailModel, useRepairTemplateDetailsModel } from "./repairTemplateDetailsModels";
import { IMaterialDetailList } from "../../repairTemplateType";
import { bigNumber, formatIntPoint, formatIntPoint1, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum, IServiceNatureCodeType } from "@/types/ScmEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ITopType } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { importPropsConfig } from "@/utils/importFile";
import useGlobalModel from "@/model/globalModel";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { RouterParamType } from "@/model/navModel";

export const MaterialTableBox: FC<RouterParamType> = ({ id, mode, parentInfo }) => {
    const { shopAndOrg: { shopId }, setLoadingInfo } = useGlobalModel()

    const {
        setMaterialModel,
        detailMaterialAddList, setDetailMaterialAddList,
        detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        detailMaterialEditList, setDetailMaterialEditList,
        detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys,

        setDetailMaterialEditDataRow,
        detailMaterialLookList,
        detailMaterialDetailList,
        setHistoryVisible,
        setHistoryRow,
        detailAddForm,
        detailEditForm,
        transformsToPoMaterialDetailList
    } = useRepairTemplateDetailsModel();
    let { priceTypeCode, serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onHistoryModel = (record: IMaterialDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const switchModelViaible = () => {
        setMaterialModel(true)
    }

    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_ADDGOOD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => switchModelViaible()}
                >新增商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_RMGOOD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailMaterialDetailList(mode, parentInfo)}
                >删除商品</Button>
            </YhAuth>
        </>}
    </>;

    const removeMaterial = (record: IMaterialDetailList) => {
        detailMaterialDetailList(mode, parentInfo, record)
    }
    const materialColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
        }, {
            title: '商品名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '商品品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '商品类型',
            width: 120,
            dataIndex: 'typeName',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: mode !== "look"
        },
        // {
        //     title: '单价',
        //     width: 100,
        //     dataIndex: 'price',
        // }, {
        //     title: '配件费',
        //     width: 100,
        //     dataIndex: 'amount',
        // },
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: mode !== "look"
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                mode !== "look" && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />

        }
    ];

    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }
    const newSelectMaterialColums = () =>
        materialColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })


    const handleMaterialSave = (row: IMaterialDetailList) => {
        let { num, price, inventoryNum, purchasePrice, termNum, latestPurPrice } = row
        price = +formatNum(price);
        let newRow = {
            ...row,
            num,
            price,
            amount: +bigNumber.times((num as number), (price as number)).toFixed(2)
        }

        let newData = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.materialCode === item.materialCode);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
    }

    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRow(selectedRows)
        }
    }
    return (
        <>
            {action}
            <Table
                style={{ marginTop: 10 }}
                bordered
                rowKey={record => record.materialCode as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectMaterialColums() as ColumnsType<IMaterialDetailList>}
                dataSource={typeMaterialList[mode] as IMaterialDetailList[]}
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailMaterialAddDataRowKeys : detailMaterialEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                            setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 630 }}
            />
        </>
    )
}